import querySerializer from 'query-string'
import Cookies from 'js-cookie'
import config from 'config'
import { redirect } from 'redux-first-router'
import { PUBLIC_PAGES } from 'actions/auth'
import {
  LOGIN_PAGE,
  MAIN_PAGE,
  SETTINGS_BILLING_PAGE,
  SEARCH_PAGE,
  LOGOUT_PAGE,
} from 'constants/pages'
import debug from 'util/debug'
import { emptyObj, deepCopy } from 'util/objects'
import storage from 'util/storage'
import {
  selectIsBillingAccountActive,
  selectIsBillingDataLoaded,
} from 'ducks/billing/selectors'
import { selectCurrentSortOrder, oauthTokenSelector } from 'selectors/app'
import {
  selectCurrentUser,
  selectCurrentUserIsOwner,
} from 'ducks/currentUser/selectors'
import { DEFAULT_SORT_ORDER } from 'constants/defaults'
import {
  V4_EMAIL_PAGE,
  V3_EMAIL_PAGE,
  V3_SIGNUP_PAGE,
  V2_SIGNUP_PAGE,
  SIGNUP_PAGE,
} from 'subapps/onboarding/pages'
import { displayConfirmLeave } from 'util/dirtyHolds'

const isAllowed = (type, token) => {
  if (token) return true
  if (PUBLIC_PAGES.includes(type)) return true
  return false
}

// Auth filtering: onBeforeChange fires before going to a new route, and you
// can redirect if certain conditions aren't met.
export default {
  querySerializer,
  onBeforeChange: (
    dispatch,
    getState,
    { action: { type, payload, meta }, action }
  ) => {
    const state = getState()
    const token = oauthTokenSelector(state)
    const currentSortOrder = selectCurrentSortOrder(state)

    if (!isAllowed(type, token)) {
      return dispatch(
        redirect({
          type: LOGIN_PAGE,
          meta,
          payload: {
            returnTo: {
              type,
              payload,
            },
          },
        })
      )
    }

    if (
      type === SETTINGS_BILLING_PAGE &&
      selectCurrentUser(state) !== emptyObj &&
      !selectCurrentUserIsOwner(state)
    ) {
      return dispatch(
        redirect({
          type: MAIN_PAGE,
        })
      )
    }

    // If your account or inbox is not active, redirect to billing page
    if (
      selectIsBillingDataLoaded(state) &&
      type !== SETTINGS_BILLING_PAGE &&
      type !== LOGOUT_PAGE &&
      !selectIsBillingAccountActive(state)
    ) {
      return dispatch(redirect({ type: SETTINGS_BILLING_PAGE }))
    }

    // If the requested search has no sort option, redirect to ?sort=newest
    if (type === SEARCH_PAGE) {
      // RFR puts query string here, if its in the URL.
      const { current } = meta.location
      const { query: { sort } = {} } = current
      // Will be populated by us below, if we redirected already.
      const { query: { sort: sortFromRedirect } = {} } = meta

      if (!sort && !sortFromRedirect) {
        debug('redirecting to search page with default sort option')

        const searchWithSort = deepCopy(action)
        // Dont know why this exists, because its the wrong way for setting a query
        if (!searchWithSort.meta.query) searchWithSort.meta.query = {}
        searchWithSort.meta.query.sort = currentSortOrder || DEFAULT_SORT_ORDER

        // This is the right way
        if (!searchWithSort.meta.location.current.query)
          searchWithSort.meta.location.current.query = {}
        searchWithSort.meta.location.current.query.sort =
          currentSortOrder || DEFAULT_SORT_ORDER

        return dispatch(redirect(searchWithSort))
      }
    }
    // If we are on a signup page, look to see if the layout variant is set and store.
    if (
      type === SIGNUP_PAGE ||
      type === V2_SIGNUP_PAGE ||
      type === V3_SIGNUP_PAGE ||
      type === V4_EMAIL_PAGE
    ) {
      // Clean up existing storage
      storage.cleanupAppStorage()

      const { current } = meta.location
      const { query: { lv: layoutVariant } = {} } = current

      if (
        (type === SIGNUP_PAGE || type === V2_SIGNUP_PAGE) &&
        layoutVariant === undefined
      ) {
        const finalVariant = 2
        Cookies.set('onboardingLayoutVariant', finalVariant, {
          domain: `.${config.appDomain}`,
          expires: 365,
        })
        storage.set('onboardingLayoutVariant', finalVariant)
      } else if (
        type === V4_EMAIL_PAGE ||
        type === V3_EMAIL_PAGE ||
        (type === V3_SIGNUP_PAGE && layoutVariant === undefined)
      ) {
        const finalVariant = 3
        Cookies.set('onboardingLayoutVariant', finalVariant, {
          domain: `.${config.appDomain}`,
          expires: 365,
        })
        storage.set('onboardingLayoutVariant', finalVariant)
      } else if (layoutVariant !== undefined) {
        const finalVariant = parseInt(layoutVariant, 10)
        Cookies.set('onboardingLayoutVariant', finalVariant, {
          domain: `.${config.appDomain}`,
          expires: 365,
        })
        storage.set('onboardingLayoutVariant', finalVariant)
      }
    }

    return true
  },
  displayConfirmLeave,
}
